import React, { Component } from 'react'

// redux 
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

// lib
import { Row, Col } from 'antd'

// sub component
import FilterPanel from './filter_panel'
import ListReports from './list_reports'
import Paginate from './paginate'

class HistoryReport extends Component{
    
    componentDidMount(){
        this.props.loadListHistoryReport()
    }

    render(){
        return (
            <div className="HistoryReport">
                <Row>
                    <Col xl={6} style={{ textAlign: 'left' }} >
                        <FilterPanel />
                    </Col>
                    <Col xl={18}>
                        <ListReports />
                        <Paginate />
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {

    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListHistoryReport: () => {
            dispatch(ReportActions.action.loadListHistoryReports({}))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HistoryReport)